export default "__VITE_ASSET__BgAuJeXP__"